import React, { useState, useEffect } from 'react';
import './Overlay.css';

const Overlay = ({ onClose }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /iPhone|iPad|iPod|Android/i;
        setIsMobile(mobileRegex.test(userAgent));
    }, []);

    return (
        <div className="overlay">
            <div className="modal">
                <button className="close-button" onClick={onClose} aria-label="Schließen">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>

                <h2>Idee im Kopf?</h2>
                <p className={isMobile ? "" : "desktop"}>
                    Wir freuen uns immer über Werkstattbesuch mit Austausch, Beratung und Brainstorming, gerne bei einem Kaffee oder einer Limo.
                    Einfach schreiben oder durchklingeln!
                </p>

                {isMobile ? (
                    <div className="modal-actions">
                        <a href="tel:+49561500550" className="modal-button-mobile">
                            <img src="assets/images/Icon_Call.svg" alt="Anrufen" className="icon" />
                            <span>Anrufen</span>
                        </a>
                        <a href="mailto:crafted@ambion.de" className="modal-button-mobile">
                            <img src="assets/images/Icon_Mail.svg" alt="Mail schreiben" className="icon" />
                            <span>Mail schreiben</span>
                        </a>
                    </div>
                ) : (
                    <>
                        <a href="mailto:crafted@ambion.de" className="modal-button" target="_blank" rel="noopener noreferrer">
                            Mail schreiben
                        </a>
                        <div className="phone">
                            <span className='typo'>Fon </span><span >+49 561 500550</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Overlay;